var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.383,
    height: 11.088,
    viewBox: "0 0 17.383 11.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M1803.616,4362.342l8.194,7.286-8.194,6.714",
    transform: "translate(4378.031 -1801.922) rotate(90)",
    fill: "none",
    stroke: "#5566c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardArrow);
export default __webpack_public_path__ + "static/media/downward_arrow.5a50a47df0fcd1b6f3d75c6e810b29f1.svg";
export { ForwardRef as ReactComponent };